import Dexie, { type Table } from 'dexie';

export interface PendingAction {
  id?: number;
  action: 'start_trip' | 'stop_trip' | 'manual_trip' | 'gps_ping' | 'approve_trip' | 'reject_trip';
  payload: Record<string, unknown>;
  createdAt: string;
  retryCount: number;
  lastError?: string;
}

export interface CachedGpsPoint {
  id?: number;
  tripId: string;
  lat: number;
  lng: number;
  accuracy: number | null;
  timestamp: string;
  synced: boolean;
}

class OfflineDatabase extends Dexie {
  pendingActions!: Table<PendingAction>;
  cachedGpsPoints!: Table<CachedGpsPoint>;

  constructor() {
    super('trackkm-offline');
    this.version(1).stores({
      pendingActions: '++id, action, createdAt',
      cachedGpsPoints: '++id, tripId, synced, timestamp',
    });
  }
}

export const offlineDb = new OfflineDatabase();
